import './Loader.css';

export const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
    </div>
  );
};